/** Build path to the device history page (embedded in Mira Business /risks). */
export function buildDeviceHistoryPath(deviceId, { serialNumber } = {}) {
  if (deviceId == null) {
    return null;
  }

  const params = new URLSearchParams();
  if (serialNumber) {
    params.set('serial', String(serialNumber));
  }

  const query = params.toString();
  return `/risks/devices/${deviceId}/history${query ? `?${query}` : ''}`;
}
